// pass in your object structure as array elements
export default (nestedObj: Object, path: string[]) =>
  path.reduce((obj: any, key: string) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined), nestedObj);
